/* =========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvents
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */
export default [
  {
    url: '/vesselTracking/RealtimeMonitoring',
    name: 'RealtmieMonitoring',
    slug: 'RealtmieMonitoring',
    icon: 'AirplayIcon',
    i18n: 'RealtimeMonitoring'
  },
  {
    url: '/vesselTracking/BaseStation',
    name: 'BaseStation',
    slug: 'BaseStation',
    icon: 'GridIcon',
    i18n: 'BaseStation'
  },
  {
    url: '/vesselTracking/Vessel',
    name: 'Vessel',
    slug: 'Vessel',
    icon: 'LifeBuoyIcon',
    i18n: 'Vessel'
  },
  {
    url: '/vesselTracking/Report',
    name: 'Reprot',
    slug: 'Report',
    icon: 'FolderIcon',
    i18n: 'VesselReport'
  },
  {
    url: '/vesselTracking/EventNotification',
    name: 'EventNotification',
    slug: 'EventNotification',
    icon: 'BellIcon',
    i18n: 'EventNotification'
  },
  {
    url: '/vesselTracking/Group',
    name: 'Group',
    slug: 'Group',
    icon: 'AnchorIcon',
    i18n: 'VesselGroup'
  },
  {
    url: '/vesselTracking/Listzone',
    name: 'Listzone',
    slug: 'Listzone',
    icon: 'StopCircleIcon',
    i18n: 'Zone'
  },
  {
    url: "/vesselTracking/Mid",
    name: 'Admin',
    slug: 'Admin',
    icon: 'SettingsIcon',
    i18n: 'Setting',
    submenu: [
      {
        url: '/vesselTracking/Mid',
        name: 'Mid',
        slug: 'Mid',
        i18n: 'MID'
      },
      {
        url: '/vesselTracking/ShipType',
        name: 'ShipType',
        slug: 'ShipType',
        i18n: 'ShipType'
      },
      {
        url: '/vesselTracking/NavigationStatus',
        name: 'NavigationStatus',
        slug: 'NavigationStatus',
        i18n: 'NavigationStatus'
      },
      {
        url: '/vesselTracking/PositionFixType',
        name: 'PositionFixType',
        slug: 'PositionFixType',
        i18n: 'PositionFixType'
      },
      {
        url: '/vesselTracking/users',
        name: 'users',
        slug: 'users',
        i18n: 'Users'
      },
    ]
  },
  

  
  // {
  //   url: '/vesselTracking/Zone',
  //   name: 'Zone',
  //   slug: 'Zone',
  //   icon: 'StopCircleIcon',
  //   i18n: 'Zone'
  // },
  
  

  
]
